<script>
import '@/assets/css/club.css';
import 'animate.css';
import {getGroupInfo, getImgList, joinUsClub, selectArticleList, selectPlayerList} from "@/api/home";
import { ClubImageEnum } from "@/enums/clubImageEnum";
import { NodeIdEnum } from "@/enums/nodeIdEnum";
import {PROVINCE_DATA} from "@/enums/provinceCityEnum";

export default {
  name: 'ClubPage',
  computed: {
    ClubImageEnum() {
      return ClubImageEnum
    },
    NodeIdEnum() {
      return NodeIdEnum;
    },
  },
  data() {
    return {
      loading: true, // 初始为true，等待所有请求完成
      richTextContent: '',
      articleList: [],
      playerList: [],
      // 优化1: 使用一个对象来管理所有图片分组，更清晰且易于维护
      imageGroups: {
        [ClubImageEnum.CLUB_44.VALUE]: [],
        [ClubImageEnum.CLUB_45.VALUE]: [],
        [ClubImageEnum.CLUB_52.VALUE]: [],
        [ClubImageEnum.CLUB_53.VALUE]: [],
        [ClubImageEnum.CLUB_54.VALUE]: [],
        [ClubImageEnum.CLUB_55.VALUE]: [],
        [ClubImageEnum.CLUB_56.VALUE]: [],
        [ClubImageEnum.CLUB_57.VALUE]: [],
        [ClubImageEnum.CLUB_58.VALUE]: [],
        [ClubImageEnum.CLUB_59.VALUE]: [],
        [ClubImageEnum.CLUB_60.VALUE]: [],
      },
      // 优化4: 使用v-model绑定表单数据
      form: {
        userName: '',
        userMobile: '',
        userExperience: '',
        province: '',
        city: '',
        userJoinMoney: '',
        acreage: '',
      },
      // 省市区相关
      provinces: PROVINCE_DATA,
      cityList: [],
    }
  },
  mounted() {
    import('wow.js').then((module) => {
      const WOW = module.default;
      this.wowInstance = new WOW().init();
    });
    this.initPageData();
  },
  beforeUnmount() {
    if (this.wowInstance) {
      this.wowInstance.destroy();
      this.wowInstance = null;
    }
  },
  created() {
    // 优化2: 使用Promise.all并行加载所有初始数据，并统一管理loading状态
    this.initPageData();

    // new WOW().init();
  },
  methods: {
    async initPageData() {
      try {
        this.loading = true;
        // 将所有API调用放入Promise.all中
        await Promise.all([
          this.fetchImages(),
          this.fetchGroupInfo(),
          this.fetchPlayerList(),
          this.fetchArticleList()
        ]);
      } catch (error) {
        console.error("页面初始化数据加载失败:", error);
        this.$message?.error("页面数据加载失败，请刷新重试");
      } finally {
        // 只有当所有Promise都完成后，loading才变为false
        this.loading = false;
      }
    },

    async fetchImages() {
      const typeStr = Object.keys(this.imageGroups).join(',');
      const res = await getImgList(typeStr);
      const dataList = res.data || [];

      // 优化1: 动态填充imageGroups对象，代码更简洁
      Object.keys(this.imageGroups).forEach(classify => {
        this.imageGroups[classify] = dataList.filter(item => item.classify === classify && item.src);
      });
    },

    async fetchGroupInfo() {
      const type = 'club_about_us';
      const res = await getGroupInfo(type);
      if (res.code === 200 && res.data && res.data.length > 0) {
        this.richTextContent = res.data[0].richText || "";
      } else {
        this.richTextContent = "";
        if(res.msg) this.$message.error(res.msg);
      }
    },

    async fetchPlayerList() {
      const res = await selectPlayerList();
      if (res.code === 200) {
        this.playerList = res.data.rows || [];
      } else {
        this.$message.error(res.msg || "获取球员列表失败");
      }
    },

    async fetchArticleList() {
      const res = await selectArticleList(NodeIdEnum.ARTICLE_TYPE_XWDT_ID.value, 1, 3);
      if (res.code === 200) {
        this.articleList = res.data.rows || [];
      } else {
        this.$message.error(res.msg || "获取文章列表失败");
      }
    },

    onPlayerClick(playerId) {
      this.$router.push({
        path: "/playerDetail",
        query: { playerId, type: "club" }
      });
    },

    handleArticleClick(item) {
      this.$router.push({
        path: "/article",
        query: { articleId: item.id, type: item.type }
      });
    },

    // 优化4: 表单提交方法
    async handleSubmit() {
      // 步骤一: 清空旧的错误信息
      this.errors = {};

      // 步骤二: 执行校验逻辑
      if (!this.form.userName) {
        this.errors.userName = '请输入您的姓名';
      }
      if (!this.form.userMobile) {
        this.errors.userMobile = '请输入您的联系方式';
      }

      if (!this.form.userExperience) {
        this.errors.userExperience = '请简单描述您对台球行业的认知';
      }
      if (!this.form.province) {
        this.errors.province = '请选择投资省份';
      }
      if (!this.form.city) {
        this.errors.city = '请选择投资城市';
      }
      if (!this.form.userJoinMoney) {
        this.errors.userJoinMoney = '请选择投资预算';
      }
      if (!this.form.acreage) {
        this.errors.acreage = '请选择投资面积';
      }

      // 步骤三: 判断校验结果
      if (Object.keys(this.errors).length > 0) {
        this.$message.error('表单信息填写不完整，请检查并修正！');
        return; // 校验失败，终止提交
      }
      //正则校验手机号
      const phoneRegex = /^1[3-9]\d{9}$/;
      if(this.form.userMobile){
        if (!phoneRegex.test(this.form.userMobile)) {
          this.$message.error('请输入有效的手机号');
          return
        }
      }

      try {
        // 合并省份和城市为 userJoinAddress
        const payload = {
          ...this.form, // 复制 form 中的所有数据
          userJoinAddress: `${this.form.province || ''}${this.form.city || ''}`
        };

        console.log('准备提交的数据:', JSON.stringify(payload));

        // 在这里调用你的提交API
        const res = await joinUsClub(payload);
        if (res.code === 200) {
          this.$message.success('申请提交成功！我们会尽快与您联系。');
          // 提交成功后可以重置表单
          this.form = {
            userName: '',
            userMobile: '',
            userExperience: '',
            province: '',
            city: '',
            userJoinMoney: '',
            acreage: '',
          };
          this.cityList = []; // 清空城市列表
          } else {
            this.$message.error(res.msg || '提交失败，请稍后重试');
          }
      } catch (error) {
        console.error("提交加盟申请失败:", error);
        this.$message.error('网络异常，提交失败');
      }

      // this.$message.success('申请提交成功！');
    },
    // 更新城市列表
    updateCityList() {
      const targetProvince = this.provinces.find((item) => item.name === this.form.province);
      this.cityList = targetProvince ? targetProvince.cities : [];
      // 清空已选城市（省份切换后重置）
      this.form.city = "";
    },
  }
}
</script>

<template>
  <div class="container-club hidden-xs-only" v-loading="loading">
    <!-- 顶部banner图 -->
    <div class="inside-banner">
      <el-carousel class="banner-carousel" loop autoplay>
        <el-carousel-item v-for="item in imageGroups[ClubImageEnum.CLUB_44.VALUE]" :key="item.id || item.src">
          <img :src="item.src" :alt="item.title" class="carousel-img" />
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 诚邀加盟 -->
    <div class="jdian-content-1">
      <div class="container">
        <div class="content-box-1">
          <div class="tag-title wow animate__animated animate__fadeInDown">
            <span>璟点台球俱乐部 / 智慧球房新体验</span>
            <strong>诚邀您的加盟</strong>
          </div>
          <ul>
            <li class="wow animate__animated animate__fadeInUp" v-for="item in imageGroups[ClubImageEnum.CLUB_45.VALUE]" :key="item.id || item.src">
              <div><img :src="item.src" :alt="item.title"></div>
              <p>{{ item.title }}<span>{{ item.description }}</span></p>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 扶持政策 -->
    <div class="container jdian-content-2">
      <div class="support-top">
        <div class="fl wow animate__animated animate__fadeInLeft pc-nr">
          <!-- 优化3: 使用可选链操作符?.防止因空数组导致的错误 -->
          <img v-if="imageGroups[ClubImageEnum.CLUB_52.VALUE]?.[0]" :src="imageGroups[ClubImageEnum.CLUB_52.VALUE][0].src" :alt="imageGroups[ClubImageEnum.CLUB_52.VALUE][0].title">
        </div>
        <div class="fr wow animate__animated animate__fadeInRight">
          <img v-if="imageGroups[ClubImageEnum.CLUB_53.VALUE]?.[0]" :src="imageGroups[ClubImageEnum.CLUB_53.VALUE][0].src" :alt="imageGroups[ClubImageEnum.CLUB_53.VALUE][0].title">
        </div>
        <div class="clearfix"></div>
      </div>
      <ul>
        <li>
          <div>
            <img v-if="imageGroups[ClubImageEnum.CLUB_54.VALUE]?.[0]" :src="imageGroups[ClubImageEnum.CLUB_54.VALUE][0].src" :alt="imageGroups[ClubImageEnum.CLUB_54.VALUE][0].title">
          </div>
        </li>
      </ul>
    </div>

    <!-- 球馆设计 -->
    <div class="jdian-content-3">
      <div class="jdian-title wow animate__animated animate__fadeInDown">
        <strong>GYMNASIUM &nbsp; DESIGN</strong>
        <h2>球馆设计</h2>
      </div>
      <div class="gymnasium-box">
        <div class="gymnasium-slide">
          <div class="swiper-slide">
            <el-carousel :interval="4000" type="card" indicator-position="none" arrow="hover" class="custom-active-carousel">
              <el-carousel-item v-for="item in imageGroups[ClubImageEnum.CLUB_55.VALUE]" :key="item.id || item.src">
                <img class="carousel-img" :src="item.src" :alt="item.title">
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </div>

    <!-- 关于我们 -->
    <div class="container jdian-content-4" id="about">
      <div class="jdian-title wow animate__animated animate__fadeInDown">
        <strong>ABOUT &nbsp;US</strong>
        <h2>关于我们</h2>
      </div>
      <div class="about-box">
        <div class="fl wow animate__animated animate__fadeInLeft">
          <img v-if="imageGroups[ClubImageEnum.CLUB_56.VALUE]?.[0]" :src="imageGroups[ClubImageEnum.CLUB_56.VALUE][0].src" :alt="imageGroups[ClubImageEnum.CLUB_56.VALUE][0].title">
        </div>
        <div class="fr wow animate__animated animate__fadeInRight">
          <img v-if="imageGroups[ClubImageEnum.CLUB_56.VALUE]?.[1]" :src="imageGroups[ClubImageEnum.CLUB_56.VALUE][1].src" :alt="imageGroups[ClubImageEnum.CLUB_56.VALUE][1].title">
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="about-container">
        <div class="about-container-content" v-html="richTextContent"></div>
      </div>
    </div>

    <!-- 签约球员 -->
    <div class="jdian-content-5" id="player">
      <div class="jdian-title-2 wow animate__animated animate__fadeInDown">签/约/球/员<span>Contract player</span></div>
      <div class="player-box container">
        <div class="swiper-container player-slide">
          <div class="swiper-slide">
            <el-carousel :interval="40000" type="card" indicator-position="none" arrow="hover" class="custom-active-carousel" height="450px">
              <el-carousel-item v-for="item in playerList" :key="item.id">
                <!-- 优化5: 移除内联样式，使用CSS类 -->
                <img class="player-card-img" @click="onPlayerClick(item.id)" :src="item.fileEchoVo.url" :alt="item.name">
                <p class="player-name"><span>{{ item.name }}</span></p>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </div>

    <!-- 新闻动态 -->
    <div class="container jdian-content-6" id="nifor">
      <div class="jdian-title-2 wow animate__animated animate__fadeInDown">新/闻/动/态<span>News Update</span></div>
      <ul class="wow animate__animated animate__fadeInUp">
        <li style="cursor: pointer" v-for="item in articleList" :key="item.id" @click="handleArticleClick(item)">
          <div>
            <div class="fl"><img class="fl" :src="item.thumbnail" :alt="item.title"></div>
            <div class="right-content">
              <span style="font-weight: 600">{{ item.keywords }}</span>
              <span class="nowrap">{{ item.time.substring(0, 10) }}</span>
              <i>———</i>
              <p>{{ item.intro || '暂无介绍' }}</p>
            </div>
            <div class="clearfix"></div>
          </div>
        </li>
      </ul>
      <div class="pagination">
        <a class="more" :href="`/articleHome?articleType=${NodeIdEnum.ARTICLE_TYPE_XWDT_ID.value}`" target="_blank">查看更多</a>
      </div>
    </div>

    <!-- 合作伙伴 -->
    <div class="jdian-content-7" id="partner">
      <div class="container">
        <div class="jdian-title-2 wow animate__animated animate__fadeInDown">战/略/合/作/伙/伴<span>Strategic Partners</span></div>
        <ul class="wow animate__animated animate__fadeInUp">
          <li v-for="item in imageGroups[ClubImageEnum.CLUB_57.VALUE]" :key="item.id || item.src">
            <a v-if="item.url" :href="item.url" target="_blank" :title="item.title">
              <img style="cursor: pointer" :src="item.src" :alt="item.title">
            </a>
            <img v-else style="cursor: pointer" :src="item.src" :alt="item.title">
          </li>
        </ul>
      </div>
    </div>

    <!-- 招商合作 -->
    <div class="jdian-content-8">
      <div class="jdian-title wow animate__animated animate__fadeInDown">
        <strong>INVESTMENT COOPERATION &nbsp;US</strong>
        <h2>招商合作</h2>
      </div>
      <div class="container join-advantage">
        <div class="jdian-title-2">联/名/店/优/势<span>Advantages of joint stores</span></div>
        <ul>
          <li  v-for="(item, index) in imageGroups[ClubImageEnum.CLUB_58.VALUE].slice(0, 8)" :key="index">
            <img :src="item.src" :alt="item.title">
            <strong v-if="index != 0">{{item.title}}</strong>
            <p v-if="index != 0">{{item.description}}</p>
          </li>
        </ul>
        <div class="adv-bot">
          <ul>
            <li class="fl">
              <img v-if="imageGroups[ClubImageEnum.CLUB_58.VALUE]?.[8]" :src="imageGroups[ClubImageEnum.CLUB_58.VALUE][8].src" :alt="imageGroups[ClubImageEnum.CLUB_58.VALUE][8].title">
              <strong v-if="imageGroups[ClubImageEnum.CLUB_58.VALUE]?.[8]">{{imageGroups[ClubImageEnum.CLUB_58.VALUE][8].title}}</strong>
            </li>
            <li class="fr">
              <p v-if="imageGroups[ClubImageEnum.CLUB_58.VALUE]?.[8]" :style="{ whiteSpace: 'pre-line' }">
                {{ imageGroups[ClubImageEnum.CLUB_58.VALUE][8].description.replace(/；/g, '\n') }}
              </p>
            </li>
          </ul>
        </div>
      </div>

      <!-- 加盟条件 -->
      <div class="join-admission">
        <div class="fl aleft wow animate__animated animate__fadeInLeft">
          <img v-if="imageGroups[ClubImageEnum.CLUB_59.VALUE]?.[0]" :src="imageGroups[ClubImageEnum.CLUB_59.VALUE][0].src" :alt="imageGroups[ClubImageEnum.CLUB_59.VALUE][0].title">
        </div>
        <div class="fl aright wow animate__animated animate__fadeInRight">
          <img v-if="imageGroups[ClubImageEnum.CLUB_59.VALUE]?.[1]" :src="imageGroups[ClubImageEnum.CLUB_59.VALUE][1].src" :alt="imageGroups[ClubImageEnum.CLUB_59.VALUE][1].title">
        </div>
      </div>

      <!-- 加盟流程 -->
      <div class="join-process">
        <div class="process-box">
          <div class="jdian-title-2 wow animate__animated animate__fadeInRight">门/店/开/业/流/程<span>Store opening process</span></div>
          <img v-if="imageGroups[ClubImageEnum.CLUB_60.VALUE]?.[0]" :src="imageGroups[ClubImageEnum.CLUB_60.VALUE][0].src" :alt="imageGroups[ClubImageEnum.CLUB_60.VALUE][0].title">
        </div>
      </div>

      <!-- 加盟申请 -->
<!--      <div class="join-bg">-->
<!--        <div class="container wow animate__animated animate__fadeInRight">-->
<!--          <strong>加盟璟点台球</strong>-->
<!--          <span>和我们一起做一个伟大的事业</span>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="container join-application">-->
<!--        <div class="jdian-title-2">加/盟/申/请<span>Application for joining</span></div>-->
<!--        <div class="join-form">-->
<!--          &lt;!&ndash; 优化4: 使用v-model绑定表单 &ndash;&gt;-->
<!--          <div class="form-group">-->
<!--            <span>您的姓名：</span>-->
<!--            <el-input type="text" v-model="form.userName" required/>-->
<!--          </div>-->
<!--          <div class="form-group">-->
<!--            <span>联系方式：</span>-->
<!--            <el-input type="text" v-model="form.userMobile" maxlength="11" required/>-->
<!--          </div>-->
<!--          <div class="form-group message">-->
<!--            <span>行业认知：</span>-->
<!--            <el-input type="textarea" v-model="form.userExperience" cols="30" rows="3" placeholder="请您简单讲讲，自己对于台球行业的了解（例如，您的球龄、球杆品牌、是否有台球从业经验等）"></el-input>-->
<!--          </div>-->
<!--          <div class="form-group">-->
<!--            <span>投资城市：</span>-->
<!--            <div class="info">-->
<!--              <div>-->
<!--                <el-select v-model="form.province" placeholder="选择省份" @change="updateCityList">-->
<!--                  <el-option-->
<!--                      v-for="(item, index) in provinces"-->
<!--                      :key="index"-->
<!--                      :label="item.name"-->
<!--                      :value="item.name"-->
<!--                  ></el-option>-->
<!--                </el-select>-->
<!--                <el-select v-model="form.city" placeholder="选择城市" :disabled="!form.province">-->
<!--                  <el-option-->
<!--                      v-for="(item, index) in cityList"-->
<!--                      :key="index"-->
<!--                      :label="item"-->
<!--                      :value="item"-->
<!--                  ></el-option>-->
<!--                </el-select>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="form-group">-->
<!--            <span>投资预算：</span>-->
<!--            <label v-for="money in ['10-30万', '31-80万', '81-130万', '131-180万', '181万以上']" :key="money">-->
<!--              <input type="radio" v-model="form.userJoinMoney" :value="money"> {{ money }}-->
<!--            </label>-->
<!--          </div>-->
<!--          <div class="form-group">-->
<!--            <span>投资面积：</span>-->
<!--            <label v-for="area in ['100~300m²', '301~500m²', '501~700m²', '701~1000m²', '1000m²以上']" :key="area">-->
<!--              <input type="radio" v-model="form.acreage" :value="area"> {{ area }}-->
<!--            </label>-->
<!--          </div>-->
<!--          <div class="form-submit">-->
<!--            <input type="button" value="提交申请" @click="handleSubmit">-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
    </div>

  </div>
</template>

<style scoped lang="scss">
// 优化5: 将内联样式移入此处
.custom-active-carousel :deep(.player-card-img) {
  object-fit: scale-down;
  width: 100%;
  height: 100%;
}

.custom-active-carousel :deep(.player-name) {
  width: 50%;
  margin: 0 auto;
  position: relative;
  bottom: 90px;
}
::v-deep .el-input__inner{
  border: none;
  font-size: 20px;
  height: 56px;
  line-height: 56px;
}
</style>